
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherPhenom } from './GenWeatherPhenom';
import moment from 'moment';

export class GenWeatherBaseline {

    auc: number;
    county: string;
    eventId: number;
    extreme: boolean;
    fipsCode: string;
    groupDistinctTypeNum: number;
    groupDuration: number;
    groupExpired: moment.Moment;
    groupIssued: moment.Moment;
    groupPhenom: string;
    groupSize: number;
    stateAbbreviation: string;
    stateName: string;
    threshold: number;
    tot: number;
    weatherPhenoms: GenWeatherPhenom[];

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherBaseline: GenWeatherBaseline);

    constructor( input?: GenWeatherBaseline ) {
        if ( input && typeof input !== 'number' ) {
            this.auc = input.auc; // float [number]
            this.county = input.county; // string [string]
            this.eventId = input.eventId; // int [number]
            this.extreme = input.extreme; // boolean [boolean]
            this.fipsCode = input.fipsCode; // string [string]
            this.groupDistinctTypeNum = input.groupDistinctTypeNum; // int [number]
            this.groupDuration = input.groupDuration; // float [number]
            if ( input.groupExpired && typeof input.groupExpired === 'string' ) {
                this.groupExpired = moment(input.groupExpired).utc();
            } else {
                this.groupExpired = input.groupExpired;
            }
            if ( input.groupIssued && typeof input.groupIssued === 'string' ) {
                this.groupIssued = moment(input.groupIssued).utc();
            } else {
                this.groupIssued = input.groupIssued;
            }
            this.groupPhenom = input.groupPhenom; // string [string]
            this.groupSize = input.groupSize; // int [number]
            this.stateAbbreviation = input.stateAbbreviation; // string [string]
            this.stateName = input.stateName; // string [string]
            this.threshold = input.threshold; // float [number]
            this.tot = input.tot; // float [number]
            if ( input.weatherPhenoms && input.weatherPhenoms.map ) { // list [GenWeatherPhenom]
                this.weatherPhenoms = input.weatherPhenoms.map( ( x: GenWeatherPhenom ) => {
                    return new GenWeatherPhenom( x );
                } );
            } else {
                this.weatherPhenoms = input.weatherPhenoms;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherBaseline[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherBaseline(a));
        } else {
          return [];
        }
    }
}

